import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'src/store';
// eslint-disable-next-line max-len
import sendRequestDesignDataPostMessageToMultiSizeAddToBasketOperation from 'src/store/app/operation/sendRequestDesignDataPostMessageToMultiSizeAddToBasketOperation';
import { closeBatchSelectionAction, setMultiSizePendingItemsAction } from 'src/store/multisize/slice';
import { BatchSelectionItem, toMultiSizeItems } from 'src/util/apparel/batchSelection';

/**
 * OP-40008: commit a confirmed editor-modal selection through the same chain as
 * the host drawer — stash the sizes, then run the design-data round-trip whose
 * host.addToBasketMultiSize callback commits via /design/batch-add. Quantities
 * are re-validated in toMultiSizeItems, and the whole path is inert unless the
 * host opened the modal.
 */
const handleBatchSelectionConfirmedOperation = (items: BatchSelectionItem[]) => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  // A commit is only ever accepted for a modal the host opened itself.
  if (!getState().multisize.isBatchSelectionOpen) {
    return;
  }
  dispatch(closeBatchSelectionAction());

  const pending = toMultiSizeItems(items || []);

  if (pending.length === 0) {
    return;
  }

  dispatch(setMultiSizePendingItemsAction(pending));
  dispatch(sendRequestDesignDataPostMessageToMultiSizeAddToBasketOperation());
};

export default handleBatchSelectionConfirmedOperation;
